import { IJobCandidateInteraction } from 'wisestep-api';

export const CandidateJobBoardCountQuery: IJobCandidateInteraction = {
  query: '',
  jobId: '',
  candidateSearchType: 'OnlyAppliedCandidates',
  candidateLocations: [],
  jobLocations: [],
  source: '',
  includeUniqueCandidatesCount: 'true',
  page: 0,
  sort: ['createdOn,desc'],
  size: 20,
};
